import { ErrorActorEvent } from 'xstate';
import { ActionEventParams, ActorErrorParams } from '../../../../lib/types';
import { FraudAlloyContext } from './fraudAlloyMachine';
import { InitializingNeuroIdResult } from './types/actors';
import { SendInitializeNeuroIdActorDone } from './types/events';

/**
 * Gets InitializingNeuroIdResult from initializeNeuroId SendInitializeNeuroIdActorDone
 * @param ActionEventParams<FraudAlloyContext, SendInitializeNeuroIdActorDone>
 * @returns InitializingNeuroIdResult
 */
export const getInitializeNeuroIdParams = ({
  event,
}: ActionEventParams<
  FraudAlloyContext,
  SendInitializeNeuroIdActorDone
>): InitializingNeuroIdResult => {
  return event.output;
};

/**
 * Gets ActorErrorParams from error event
 * @param ActionEventParams<FraudAlloyMachineEvents, ErrorActorEvent>
 * @returns ActorErrorParams
 */
export const getServiceErrorParams = ({
  event,
}: ActionEventParams<FraudAlloyContext, ErrorActorEvent>): ActorErrorParams => {
  const errorOutput = event.error as ActorErrorParams;

  return {
    type: event.type,
    error: errorOutput.error,
    reject: errorOutput.reject,
  };
};
